module.exports = __webpack_public_path__ + "static/media/inbox-on.b40e145b.svg";